import "can/model/";


export default can.Model.extend({
    findAll: function () {
        "use strict";

        return can.ajax({
            url: "/api/v2/myUser",
            type: "GET",
            dataType: "json",
            error: function (document) {
                switch (document.status) {
                    case 401:
                    case 500:
                        const accessToken = sessionStorage.getItem('authToken');
                        if (accessToken) {
                            sessionStorage.removeItem('authToken');
                        }
                        window.location.replace("login.html");
                        break;
                }
            }
        });
    },

    parseModels(data) {
        return [data];
    }
}, {});
